export default __webpack_public_path__ + "static/media/risk.517577a7.svg";